module.exports = __webpack_public_path__ + "4eef8e04161c3d41608244fd28db0d45.woff2";